import { modelMappingConfigSlice } from "./ModelMappingConfig.redux";


export const {
    resetModelMapping,
    setModelProviderInput
} = modelMappingConfigSlice.actions